import React, { useState } from "react";
import supabase from "../../supabaseClient";
import { useNavigate } from "react-router-dom";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();

    const { data, error } = await supabase.auth.signInWithPassword({
      email,
      password,
    });

    if (error) return setError(error.message);

    localStorage.setItem("adminSession", JSON.stringify(data.session));
    navigate("/admin");
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-100">
      <form
        onSubmit={handleLogin}
        className="bg-white p-8 shadow rounded-lg w-80 space-y-4"
      >
        <h2 className="text-xl font-bold text-center">Admin Login</h2>
        {error && <p className="text-red-600 text-sm">{error}</p>}

        <label htmlFor="admin-email" className="sr-only">Admin Email</label>
        <input
          id="admin-email"
          type="email"
          autoComplete="username"
          className="w-full border rounded p-2"
          placeholder="Admin Email"
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <label htmlFor="admin-password" className="sr-only">Password</label>
        <input
          id="admin-password"
          type="password"
          autoComplete="current-password"
          className="w-full border rounded p-2"
          placeholder="Password"
          onChange={(e) => setPassword(e.target.value)}
          required
        />

        <button type="submit" className="bg-green-700 w-full text-white py-2 rounded">
          Login
        </button>
      </form>
    </div>
  );
}
